import { SensorsAccessoriesPageVariables } from 'src/sensors/accessories/SensorsAccessoriesPageMapping.ts';
import { skipToken } from '@apollo/client';
import { composeFilter, Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { UserSettings } from 'src/types/UserSettings.ts';

export const buildCheckoutVariables = ({
    mandatoryFilterConfig,
    filter,
    sensorLabel,
    userSettings,
}: {
    mandatoryFilterConfig: { config: FilterConfig; values: Filter };
    filter: Filter;
    sensorLabel: string;
    userSettings: UserSettings;
}): { variables: SensorsAccessoriesPageVariables } | typeof skipToken => {
    if (filter === null) {
        return skipToken;
    }
    return {
        variables: {
            filter: composeFilter(
                mandatoryFilterConfig.config,
                mandatoryFilterConfig.values,
                userSettings.currentLocale,
            ),
            label: sensorLabel,
            locale: userSettings.currentLocale,
        },
    };
};
